export default __webpack_public_path__ + "static/media/manual07.25f12fa0.png";